export default {
    "error_422": "Vă rugăm să completați corect câmpurile",
    "trashed_failed": "Nu s-a putut șterge!",
    "trashed_success": "Șters cu succes!",
    "api_timeout": "API-ul nu răspunde, încercați din nou mai târziu!",
    "please_wait": "Vă rugăm să așteptați...",
    "long_operation": "Operație de lungă durată, vă rugăm să așteptați...",
}
